import { Sites } from '@ps/platform-message-framework/common/Sites';

export { type Response } from '@ps/web-core-store';

/* eslint-disable no-bitwise */

// TODO: EmailFlags should be merged with UserFlags above
export enum EmailFlag {
  Verified = 1 << 0,
  Bounced = 1 << 6,
  NotAuthorized = 1 << (51 - 32),
  AlwaysValidated = 1 << (50 - 32)
}

export interface EmailValidationFlags {
  verified: boolean;
  bounced: boolean;
  notAuthorized: boolean;
  alwaysValidated: boolean;
}

export interface AccountLocales {
  emLocale: number;
  emLocale2: number;
  emLocale3: number;
}

export interface AccountInfo {
  name?: string;
  addr1?: string;
  city?: string;
  zipCode?: string;
  state?: string;
  country?: string;
  countryCode?: string;
  phone?: string;
}

export const depositLimitExtendedSites = [
  Sites.COM,
  Sites.DE,
  Sites.DE_SH,
  Sites.DEN,
  Sites.SPA,
  Sites.EU,
  Sites.GR,
  Sites.NL,
  Sites.POR,
  Sites.ROM,
  Sites.SWE,
  Sites.UK,
  Sites.US_CO,
  Sites.USMI,
  Sites.US_NJ,
  Sites.US_PA,
  Sites.CA_ON
];

export enum UpdateAccountDetailsAction {
  Cancel,
  Confirm,
  Update
}
